import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { requestListReq, updateRequestStatusReq, updateRequestStatusReStatus } from '../../../redux/request/request.action'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const EmployeeRequestList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const { state } = useLocation()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { requestListSuccess, requestListError, updateRequestStatusSuccess, updateRequestStatusError, updateRequestStatusReqStatus
    } = useSelector(state => state.request)
    const [selectedRequest, setSelectedRequest] = useState()
    const [showRequestDetailModal, setShowRequestDetailModal] = useState(false)
    const [showRejectModal, setShowRejectModal] = useState(false)
    const [rejectReason, setRejectReason] = useState('')
    const PENDING_STATUS = { key: APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) }
    const REQUEST_STATUS_LIST = [
        PENDING_STATUS,
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) },
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) }
    ]
    const [selectedStatus, setSelectedStatus] = useState(PENDING_STATUS)

    useEffect(() => {
        console.log('state', state);

        if (!isEmpty(state.requestType)) {
            fetchRequestList(null, state.requestType)
        } else {
            fetchRequestList(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING)
        }
    }, [])

    const fetchRequestList = (status = null, requestType = null) => {
        setLoading(true)
        const data = {
            requestorId: state.requestorId
        }
        if (!isEmpty(requestType)) {
            data.requestType = requestType
        }
        if (!isEmpty(status)) {
            data.status = status
        }
        data.businessId = state.businessId
        data.locationId = state.locationId
        // data.status = selectedStatus.key
        dispatch(requestListReq(data))
    }

    useEffect(() => {
        if (!isEmpty(requestListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(requestListError)) {
            setLoading(false)
        }
    }, [requestListSuccess, requestListError])

    useEffect(() => {
        if (updateRequestStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateRequestStatusSuccess.data.message)
            fetchRequestList()
        } else if (updateRequestStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateRequestStatusError.message)
        }
        if (updateRequestStatusReqStatus?.length) {
            dispatch(updateRequestStatusReStatus(''))
        }
    }, [updateRequestStatusSuccess, updateRequestStatusError, updateRequestStatusReqStatus])

    const handleViewDetail = item => {
        setSelectedRequest(item)
        setShowRequestDetailModal(true)
    }

    const handleRequestUpdateStatusClick = (status) => {
        if (isEmpty(selectedRequest)) {
            displayErrorToast('Something went wrong. Please try again')
        } else if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED && isEmpty(rejectReason)) {
            displayErrorToast('Request reject reason cannot be blank')
        } else {
            setLoading(true)
            const data = {
                requestId: selectedRequest.requestId,
                status: status
            }
            if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
                data.rejectReason = rejectReason
            }
            dispatch(updateRequestStatusReq(data))
            setShowRequestDetailModal(false)
            setShowRejectModal(false)
        }
    }

    useEffect(() => {
        if (!isEmpty(selectedStatus)) {
            if (!isEmpty(state.requestType)) {
                fetchRequestList(selectedStatus.key, state.requestType)
            } else {
                fetchRequestList(selectedStatus.key)
            }
        }
    }, [selectedStatus])

    const getStatusClassName = (e, selectedStatus) => {
        if (e.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) {
            if (selectedStatus.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) {
                return 'tl-status-item tl-status-item-selected-blue'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) {
            if (selectedStatus.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) {
                return 'tl-status-item tl-status-item-selected-green'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
            if (selectedStatus.key === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
                return 'tl-status-item tl-status-item-selected-red'
            } else {
                return 'tl-status-item'
            }
        } else {
            if (selectedStatus.key === 'MY_TEAM') {
                return 'tl-status-item tl-status-item-selected-dark-green'
            } else {
                return 'tl-status-item'
            }
        }
    }

    const getDetailStatusClassname = (status) => {
        if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING) {
            return 'pd-status-container pd-status-container-blue'
        } else if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.REQUEST, PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST, state.businessId, state.locationId)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Employee Requests' />
                <div className="tl-status-row-container">
                    {!isEmpty(REQUEST_STATUS_LIST) && <div className="tl-status-parent-container">
                        <div className="tl-status-container">
                            {REQUEST_STATUS_LIST.map(e => (
                                <div className={getStatusClassName(e, selectedStatus)} onClick={() => setSelectedStatus(e)}>{e.value}</div>
                            ))}
                        </div>
                    </div>}
                </div>
                {!isNull(requestListSuccess) && !isEmpty(requestListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Employee Id</th>
                                <th scope="col" className="text-center">Request Type</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.requestorDetails?.firstName} {element.requestorDetails?.lastName}</td>
                                    <td className="text-center">{!isEmpty(element.requestorDetails?.employeeBusinessMapping[0]?.employeeCode) ? element.requestorDetails.employeeBusinessMapping[0].employeeCode : '-'}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.requestType)}</td>
                                    <td className="text-center">{moment.utc(element.requestDate).local().format('DD/MM/YYYY')}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.status)}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(requestListError) && <div className="content-error">{requestListError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowRequestDetailModal(false) }}
                show={showRequestDetailModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Request Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(selectedRequest) && <div>
                        <div className={getDetailStatusClassname(selectedRequest.status)}>{removeSpecialCharAndChangeToPascal(selectedRequest.status)}</div>
                        <div className="rl-detail-name-label">{selectedRequest.requestorDetails?.firstName} {selectedRequest.requestorDetails?.lastName}</div>
                        <div className="rl-detail-id-label">{!isEmpty(selectedRequest.requestorDetails?.employeeCode) ? selectedRequest.requestorDetails.employeeCode : ''}</div>
                        <FormFieldLabel label='Request Details' />
                        <div className="rl-detail-type-label">Request Type: {removeSpecialCharAndChangeToPascal(selectedRequest.requestType)}</div>
                        <div className="rl-detail-date-label">Request Date: {moment.utc(selectedRequest.requestDate).local().format('DD/MM/YYYY')}</div>
                        <div className="rl-detail-description-label">{selectedRequest.description}</div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST) && selectedRequest.status === APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.PENDING && <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => {
                                setShowRequestDetailModal(false)
                                setShowRejectModal(true)
                            }}>REJECT</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleRequestUpdateStatusClick(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.APPROVED) }}>APPROVE</div>
                        </div>}
                    </div>}
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowRejectModal(false) }}
                show={showRejectModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Reject Request
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CommonInputFloatFull
                        type='text'
                        id='rejectReason'
                        onChange={e => setRejectReason(e.target.value)}
                        placeholder='Reason'
                        value={rejectReason}
                        rows={2}
                        multiline={true}
                    />
                    <div className="at-modal-btn-container">

                        <div className="at-modal-no-btn" onClick={() => { handleRequestUpdateStatusClick(APP_CONSTANTS.EMPLOYEE_REQUEST_STATUS_TYPE.REJECTED) }}>CONFIRM</div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EmployeeRequestList